<template>
  <div style="padding: 24px; position: relative">
    <q-page style="z-index: 2">
      <div class="row col-12 justify-between align-center">
        <p class="text-h6 text-brand-1 text-weight-bolder items-center">
          Retirada de Materiais
          <span v-if="userData?.nome">{{ "-" + " " + userData?.nome }}</span>
        </p>
        <span
          style="cursor: pointer"
          class="row justify-end q-mt-md q-mb-md"
          @click="
            (userData.nome = ''), (grupoSelected = null), (firstStep = true)
          "
        >
          <router-link
            :to="{ name: 'spf-inicial' }"
            @click="
              (userData.nome = ''), (grupoSelected = null), (firstStep = true)
            "
            class="row align-center"
          >
            <q-icon
              label="voltar"
              class="q-mr-sm"
              color="grey"
              size="sm"
              name="west"
            />
            <span style="color: #8a8a8a; font-size: 20px">Voltar</span>
          </router-link>
        </span>
      </div>
      <div
        v-if="
          $store.state.autenticacao.cliente.includes('staging-vale') ||
          $store.state.autenticacao.cliente.includes('vale-epiexpress')
        "
        class="row col-12 text-brand-5 text-weight-bold q-mt-lg"
      >
        <div class="row col-12 container-video q-gutter-sm">
          <div class="row col-12 items-center texto-link">
            <a
              href="https://multpex.movidesk.com/kb/article/364416/configuracao-leitor-biometrico-web"
              target="_blank"
            >
              <q-icon class="q-mr-xs" name="link" size="22px" />Procedimento de
              Configuração e Utilização do Leitor Biométrico</a
            >
          </div>
          <div class="row justify-center">
            <div class="col-md">
              <q-video
                src="https://www.youtube.com/embed/oX-NzE34JEU?si=o0thKOfuUz9SCjVB"
                class="video"
              />
              <div class="row col-12 justify-center texto-link-legenda">
                Configuração do Leitor
              </div>
            </div>
            <div class="col-md q-ml-xl sem-margin">
              <q-video
                src="https://www.youtube.com/embed/ZeNPIZtbTj4?si=mVcNkcQXy4H3nVRn"
                class="video"
              />
              <div class="row col-12 justify-center texto-link-legenda">
                Funcionamento Fluxo Completo
              </div>
            </div>
          </div>
        </div>
      </div>
      <span v-if="userData.nome == ''" style="font-size: 16px; color: #21324a"
        >Selecione a unidade e o colaborador para a retirada</span
      >
      <div
        v-if="userData.nome == ''"
        class="row col-12 text-weight-bold text-brand-5 q-mt-md q-gutter-sm container-inputs"
      >
        <div class="col-md-3 col-sm-5 col-xs-5">
          <div class="texto-titulo-input q-ml-md">Unidade</div>
          <lista-unidades-select
            class="input-new-design"
            v-model="unidade.nome"
          ></lista-unidades-select>
        </div>

        <div class="col-md-4 col-sm-6 col-xs-6">
          <div class="texto-titulo-input q-ml-md">Solicitante</div>
          <SelecaoSolicitante
            class="input-new-design"
            @emitirFuncionario="receberFuncionario"
            :atualizarDados="atualizarUsuario"
          />
        </div>
      </div>

      <span
        v-if="userData.nome"
        class="align row"
        style="
          width: 100%;
          font-size: 16px;
          color: #21324a;
          display: block;
          margin-top: 20px;
        "
        >Utilize o campo abaixo para filtrar por grupo de produto
        <span class="row align">
          <q-select
            label="Pesquisar Grupo de Produtos"
            class="input-new-design q-mt-sm col-12 col-md-4 col-sm-4"
            dense
            outlined
            v-model="grupoSelected"
            hide-bottom-space
            @filter="filtrarCusto"
            :options="grupoProdutoList"
            hide-selected
            use-input
            :option-label="
              (opt) => (Object(opt) === opt && 'name' in opt ? opt.name : '')
            "
          />
          <div
            v-if="grupoSelected?.name"
            class="row q-mt-sm q-ml-md text-brand-5 text-weight-bold"
          >
            <div>
              <span class="row q-mr-sm items-center card-nome-usuario"
                >{{ grupoSelected?.name
                }}<q-icon
                  style="cursor: pointer"
                  class="q-ml-sm"
                  name="close"
                  size="18px"
                  @click="grupoSelected = null"
              /></span>
            </div>
          </div>
        </span>
      </span>
      <q-table
        v-if="userData.nome != '' && firstStep"
        :columns="columns"
        :rows="listaProdutos"
        :loading="loading"
        :rows-per-page-options="[0]"
        color="primary"
        table-header-class="bg-accent text-width-bold"
        class="table-style-simple q-mt-lg"
        style="min-height: 370px"
        dense
        row-key="id"
        v-model:selected="produtosSelecionadosNew"
        flat
        hide-bottom
      >
        <template v-slot:top-left>
          <div class="row align">
            <span style="display: block; font-size: 16px; color: #21324a"
              >Produtos Liberados</span
            >

            <div>
              <q-btn
                no-caps
                style="border-radius: 8px"
                class="q-ml-sm q-mt-sm"
                color="brand-1"
                @click="(tipo = 'vencidos'), listarProdutosLiberados()"
                label="Vencidos"
              />
            </div>

            <div>
              <q-btn
                no-caps
                style="border-radius: 8px"
                class="q-ml-sm q-mt-sm"
                color="brand-2"
                @click="(tipo = 'recentes'), listarProdutosLiberados()"
                label="Recentes"
              />
            </div>
            <div>
              <q-btn
                no-caps
                style="border-radius: 8px"
                class="q-ml-sm q-mt-sm"
                color="brand-2"
                @click="(tipo = undefined), listarProdutosLiberados()"
                label="Todos"
              />
            </div>
          </div>
        </template>
        <template v-slot:top-right>
          <div class="row align">
            <input-component-new
              label="Pesquisar produtos"
              style="min-width: 360px"
              class="q-mr-sm row"
              v-model="filtros.produto"
            ></input-component-new>
          </div>
        </template>

        <template v-slot:body-cell-quantidade="props">
          <q-td
            :style="{
              'background-color':
                props.row.critico == 1 && compararDataCritico(props.row)
                  ? '#FBA6B4'
                  : '',
            }"
            class="text-brand-5"
            :props="props"
          >
            <q-input
              dense
              type="number"
              input-style="text-align:center"
              style="width: 50px; text-align: center"
              v-model="props.row.quantidade"
              min="0"
              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
            />
          </q-td>
        </template>

        <template v-slot:body-cell-retirada="props">
          <q-td
            :style="{
              'background-color':
                props.row.critico == 1 && compararDataCritico(props.row)
                  ? '#FBA6B4'
                  : '',
            }"
            class="text-brand-5"
            :props="props"
          >
            <span v-if="props.row.next_minimum_withdrawal == null"
              >Nunca Retirado
            </span>

            <span v-else-if="props.row.pode_retirar == 'Sim'"
              >Pode Retirar
            </span>
            <span
              v-if="
                props.row.next_minimum_withdrawal != null &&
                props.row.pode_retirar != 'Sim'
              "
            >
              {{ compararData(props.row, props.row.pode_retirar) }} (Faltam
              {{
                calcularDiasFaltando(
                  props.row?.next_minimum_withdrawal?.split(" ")[0]
                )
              }}
              dias)</span
            >
          </q-td>
        </template>

        <template v-slot:body-cell-adicionar="props">
          <q-td
            :style="{
              'background-color':
                props.row.critico == 1 && compararDataCritico(props.row)
                  ? '#FBA6B4'
                  : '',
            }"
            :props="props"
          >
            <q-btn
              :disable="
                compararDataValue(props.row, props.row.pode_retirar) ||
                verificarQuantidade(props.row) ||
                props.row.quantidade == undefined ||
                props.row.quantidade == 0
              "
              :color="
                produtosSelecionadosNew.find((value) => {
                  return value.id == props.row.id;
                }) == undefined
                  ? 'blue-6'
                  : 'negative'
              "
              round
              size="sm"
              :icon="
                produtosSelecionadosNew.find((value) => {
                  return value.id == props.row.id;
                }) == undefined
                  ? 'add'
                  : 'close'
              "
              @click="
                produtosSelecionadosNew.find((value) => {
                  return value.id == props.row.id;
                }) == undefined
                  ? produtosSelecionadosNew.push(props.row)
                  : produtosSelecionadosNew.splice(
                      produtosSelecionadosNew.findIndex((value) => {
                        return value.id == props.row.id;
                      }),
                      1
                    )
              "
            >
              <q-tooltip
                anchor="top middle"
                self="bottom middle"
                v-if="
                  compararDataValue(props.row, props.row.pode_retirar) ||
                  verificarQuantidade(props.row) ||
                  props.row.quantidade == undefined ||
                  props.row.quantidade == 0
                "
              >
                <span
                  v-if="
                    props.row.quantidade == undefined ||
                    props.row.quantidade == 0
                  "
                >
                  Informe a quantidade antes de adicionar ao carrinho
                </span>
                <span
                  v-else-if="
                    compararDataValue(props.row, props.row.pode_retirar) ||
                    verificarQuantidade(props.row)
                  "
                >
                  Você ja atingiu a quantidade maxima de retirada, observe a
                  data da Proxima Retirada
                </span>
              </q-tooltip>
            </q-btn>
          </q-td>
        </template>

        <template v-slot:body-cell-image="props">
          <q-td
            :style="{
              'background-color':
                props.row.critico == 1 && compararDataCritico(props.row)
                  ? '#FBA6B4'
                  : '',
            }"
            :props="props"
          >
            <q-img
              v-if="props.row?.product_images.length != 0"
              style="width: 48px; height: 48px"
              :src="props.row?.product_images[0]?.url"
              fit="contain"
              class="img-grid"
            />

            <q-img
              v-else
              style="width: 48px; height: 48px"
              src="../../../assets/imageDefoult.jpg"
              fit="contain"
              class="img-grid"
            />
          </q-td>
        </template>

        <template v-slot:body-cell-code="props">
          <q-td
            :style="{
              'background-color':
                props.row.critico == 1 && compararDataCritico(props.row)
                  ? '#FBA6B4'
                  : '',
            }"
            :props="props"
          >
            <span>{{ props.row.code }}</span>
          </q-td>
        </template>

        <template v-slot:body-cell-max_amount="props">
          <q-td
            :style="{
              'background-color':
                props.row.critico == 1 && compararDataCritico(props.row)
                  ? '#FBA6B4'
                  : '',
            }"
            :props="props"
          >
            <span>{{ props.row.max_amount }}</span>
          </q-td>
        </template>
        <template #body-cell-critico="props">
          <q-td
            :style="{
              'background-color':
                props.row.critico == 1 && compararDataCritico(props.row)
                  ? '#FBA6B4'
                  : '',
            }"
          >
            <span v-if="props.row.critico == 1">SIM</span>
            <span v-else>NÃO</span>
          </q-td>
        </template>
        <template v-slot:body-cell-name="props">
          <q-td
            :style="{
              'background-color':
                props.row.critico == 1 && compararDataCritico(props.row)
                  ? '#FBA6B4'
                  : '',
            }"
            :props="props"
          >
            <span>{{ props.row.name }}</span>
            <div
              v-if="props.row.critico == 1 && compararDataCritico(props.row)"
              style="color: white"
              class="text-left"
            >
              (Atenção, a não retirada deste item está BLOQUEANDO a retirada de
              todos os outros itens. )
            </div>
          </q-td>
        </template>

        <template v-slot:body-cell-estoque="props">
          <q-td
            :style="{
              'background-color':
                props.row.critico == 1 && compararDataCritico(props.row)
                  ? '#FBA6B4'
                  : '',
            }"
            :props="props"
          >
            <span>{{ props.row?.estoque }}</span>
          </q-td>
        </template>
      </q-table>
      <div
        v-if="userData.nome != '' && firstStep"
        class="row justify-center q-mt-md"
      >
        <q-pagination
          :disable="loading"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          :size="mobile ? 'md' : 'sm'"
        />
      </div>

      <TabelaHistoricoRetirada
        :solicitanteId="dados?.usuario?.sap"
        :item="item"
        :atualizar="atualizarHistorico"
      />

      <q-dialog v-model="carrinhoModal" persistent>
        <q-card
          style="height: 568px; max-width: 100%; min-width: 400px"
          class="q-pa-sm text-brand-5 text-weight-bolder"
        >
          <q-card-section class="row items-center">
            <span
              class="text-brand-1"
              style="
                font-size: 20px;
                width: 100%;
                justify-content: center;
                align-items: center;
                display: flex;
              "
              >Resumo da retirada</span
            >
          </q-card-section>
          <q-separator />
          <q-card-section
            style="min-height: 430px; max-height: 430px"
            class="q-ml-sm row"
          >
            <q-table
              :columns="columns2"
              table-header-class="bg-accent text-width-bold"
              :rows="produtosSelecionadosNew"
              :loading="loading"
              :rows-per-page-options="[0]"
              style="max-height: 400px; min-width: 520px; width: 100%"
              color="primary"
              class="table-style-simple"
              dense
              flat
              hide-bottom
            >
              <template v-slot:body-cell-quantidade="props">
                <q-td class="text-brand-5 text-weight-bold" :props="props">
                  <q-input
                    dense
                    type="number"
                    input-style="text-align:center"
                    style="width: 50px; text-align: center"
                    v-model="props.row.quantidade"
                    min="0"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  >
                    <q-tooltip
                      no-parent-event
                      :model-value="
                        compararDataValue(props.row, props.row.pode_retirar) ||
                        verificarQuantidade(props.row) ||
                        props.row.quantidade == undefined ||
                        props.row.quantidade == 0
                      "
                      class="bg-negative"
                      anchor="top middle"
                      self="bottom middle"
                      :offset="[10, 10]"
                    >
                      Quantidade digitada muito acima ou zero
                    </q-tooltip>
                  </q-input>
                </q-td>
              </template>
              <template v-slot:body-cell-image="props">
                <q-td :props="props">
                  <q-img
                    v-if="props.row?.product_images.length != 0"
                    style="width: 48px; height: 48px"
                    :src="props.row?.product_images[0]?.url"
                    fit="contain"
                    class="img-grid"
                  />

                  <q-img
                    v-else
                    style="width: 48px; height: 48px"
                    src="../../../assets/imageDefoult.jpg"
                    fit="contain"
                    class="img-grid"
                  />
                </q-td>
              </template>
              <template v-slot:body-cell-remover="props">
                <q-td :props="props">
                  <q-btn
                    :color="
                      produtosSelecionadosNew.find((value) => {
                        return value.id == props.row.id;
                      }) == undefined
                        ? 'blue-6'
                        : 'negative'
                    "
                    round
                    size="sm"
                    :icon="
                      produtosSelecionadosNew.find((value) => {
                        return value.id == props.row.id;
                      }) == undefined
                        ? 'add'
                        : 'close'
                    "
                    @click="
                      produtosSelecionadosNew.find((value) => {
                        return value.id == props.row.id;
                      }) == undefined
                        ? produtosSelecionadosNew.push(props.row)
                        : produtosSelecionadosNew.splice(
                            produtosSelecionadosNew.findIndex((value) => {
                              return value.id == props.row.id;
                            }),
                            1
                          )
                    "
                  >
                    <q-tooltip>Remover Item</q-tooltip>
                  </q-btn>
                </q-td>
              </template>
            </q-table>
          </q-card-section>
          <div class="row justify-between items-align">
            <q-card-actions align="left">
              <q-btn
                icon="chat"
                round
                @click="commentModal = !commentModal"
                style="border-radius: 8px"
                class="q-ml-sm"
                color="white"
                text-color="brand-1"
              />
              <q-tooltip>Comentários</q-tooltip>
            </q-card-actions>
            <q-card-actions align="right">
              <q-btn
                icon="done"
                no-caps
                style="border-radius: 8px"
                class="q-ml-sm"
                color="brand-1"
                :loading="loadingCriarReq"
                label="Criar Retirada"
                @click="criarRequisicao"
                :disable="
                  produtosSelecionadosNew.length == 0 ||
                  produtosSelecionadosNew.filter((value) => {
                    return (
                      verificarQuantidade(value) == false &&
                      value.quantidade != 0
                    );
                  }).length != produtosSelecionadosNew.length
                "
                v-close-popup
              />

              <q-btn
                icon="close"
                no-caps
                style="border-radius: 8px"
                class="q-ml-sm"
                color="white"
                text-color="brand-1"
                label="Cancelar"
                v-close-popup
              />
            </q-card-actions>
          </div>
        </q-card>
      </q-dialog>

      <q-dialog v-model="authModal" persistent>
        <q-card
          style="height: 650px; max-width: 700px; min-width: 700px"
          class="q-pa-sm text-brand-5 text-weight-bolder"
        >
          <q-card-section class="row items-center">
            <span
              class="text-brand-1"
              style="
                font-size: 20px;
                width: 100%;
                justify-content: center;
                align-items: center;
                display: flex;
              "
              >Autenticar retirada</span
            >
          </q-card-section>
          <q-separator />
          <q-card-section style="min-height: 500px" class="q-ml-sm">
            <span
              style="
                display: block;
                font-size: 16px;
                color: #21324a;
                margin-top: 5px;
                margin-bottom: 5px;
                font-weight: normal;
              "
              >Escolha abaixo o método de autenticação que deseja:</span
            >
            <q-tabs
              v-model="tab"
              dense
              active-color="black"
              no-caps
              active-bg-color="brand-11"
              indicator-color="primary"
              align="justify"
              narrow-indicator
            >
              <q-tab
                style="background-color: #d9d9d9; border-radius: 4px"
                name="aprovacao"
                label="Assinatura"
                @click="dados.tipoAutenticacao = 'assinatura'"
                v-if="
                  !$store.state.autenticacao.cliente.includes('staging-vale') &&
                  !$store.state.autenticacao.cliente.includes(
                    'vale-epiexpress'
                  ) &&
                  $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
                    'voucher-auth-assinatura'
                  ) != -1
                "
              />
              <q-tab
                style="background-color: #d9d9d9; border-radius: 4px"
                name="finalizacao"
                class="q-ml-sm q-mr-sm"
                label="Biometria"
                @click="dados.tipoAutenticacao = 'biometria'"
                v-if="
                  $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
                    'voucher-auth-biometria'
                  ) != -1
                "
              />
              <q-tab
                style="background-color: #d9d9d9; border-radius: 4px"
                name="finalizadas"
                class="q-mr-sm"
                label="Facial"
                @click="dados.tipoAutenticacao = 'facial'"
                v-if="
                  $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
                    'vouchers-auth-facial'
                  ) != -1
                "
              />
              <q-tab
                style="background-color: #d9d9d9; border-radius: 4px"
                name="deletadas"
                label="Pin"
                @click="dados.tipoAutenticacao = 'web_pin'"
                v-if="
                  !$store.state.autenticacao.cliente.includes(
                    'staging-acciona'
                  ) &&
                  !$store.state.autenticacao.cliente.includes('acciona') &&
                  $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
                    'voucher-auth-pin'
                  ) != -1
                "
              />
            </q-tabs>

            <q-tab-panels v-model="tab" animated>
              <q-tab-panel
                name="aprovacao"
                v-if="
                  $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
                    'voucher-auth-assinatura'
                  ) != -1
                "
              >
                <div class="row col-12 q-mt-md canvas-container">
                  <span
                    style="font-size: 16px"
                    class="row col-12 q-mb-sm text-brand-1 text-weight-bold"
                    >Utilize o campo abaixo para fazer a assinatura:</span
                  >
                  <Canvas @update="recebeAssinatura" :go="salvarAssinatura" />
                </div>
              </q-tab-panel>

              <q-tab-panel
                name="finalizacao"
                v-if="
                  $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
                    'voucher-auth-biometria'
                  ) != -1
                "
              >
                <ComponenteBiometria
                  :idUsuario="dados.usuario.idTabela"
                  :tipoMetodo="'verificacao'"
                  :hiddenLeftContainer="true"
                  @resultadoVerificacao="receberResultadoBiometria"
                />
              </q-tab-panel>
              <q-tab-panel
                name="finalizadas"
                v-if="
                  $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
                    'vouchers-auth-facial'
                  ) != -1
                "
              >
                <ComponenteBiometriaFacial
                  :hiddenLeftContainer="true"
                  @resultadoVerificacao="receberFace"
                  :idUsuario="dados.usuario.idTabela"
                  :tipoMetodo="'verificacao'"
                  :autoFinalize="true"
                />
              </q-tab-panel>
              <q-tab-panel
                name="deletadas"
                v-if="
                  $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
                    'voucher-auth-pin'
                  ) != -1
                "
              >
                <span
                  style="
                    display: block;
                    font-size: 16px;
                    color: #21324a;
                    margin-top: 5px;
                    font-weight: normal;
                    margin-left: 25px;
                  "
                  >Informe o PIN para a autenticação:</span
                >
                <div
                  class="row col-12 q-mt-md items-center container-autenticacao-pin"
                >
                  <q-icon class="q-mr-xs" name="lock" size="28px" />
                  <div class="col-md-2 col-xs-6">
                    <q-input v-model="pin" type="password" dense outlined />
                  </div>
                </div>
              </q-tab-panel>
            </q-tab-panels>
          </q-card-section>

          <q-card-actions
            align="right"
            v-if="dados.tipoAutenticacao !== 'facial'"
          >
            <q-btn
              icon="done"
              no-caps
              style="border-radius: 8px"
              class="q-ml-sm"
              color="brand-1"
              label="Finalizar Retirada"
              @click="
                dados.tipoAutenticacao == 'web_pin' ? checarPin() : '';
                dados.tipoAutenticacao == 'assinatura'
                  ? salvarAssinatura++
                  : '';
                dados.tipoAutenticacao == 'biometria'
                  ? finalizarRequisicao()
                  : '';
                dados.tipoAutenticacao == 'token' ? finalizarRequisicao() : '';
                dados.tipoAutenticacao == ''
                  ? quasar.notify({
                      message: 'Selecione um método de autenticação',
                      color: 'negative',
                      actions: [
                        {
                          label: 'fechar',
                          color: 'white',
                          handler: () => {
                            /* ... */
                          },
                        },
                      ],
                    })
                  : '';
              "
              v-close-popup
            />

            <q-btn
              icon="close"
              no-caps
              style="border-radius: 8px"
              class="q-ml-sm"
              color="white"
              text-color="brand-1"
              label="Cancelar"
              @click="resetState"
            />
          </q-card-actions>
        </q-card>
      </q-dialog>
      <q-dialog v-model="commentModal" persistent>
        <q-card
          style="height: 340px; max-width: 100%"
          class="q-pa-sm text-brand-5 text-weight-bolder"
        >
          <q-card-section class="row items-center">
            <span
              class="text-brand-1"
              style="
                font-size: 20px;
                width: 100%;
                justify-content: center;
                align-items: center;
                display: flex;
              "
              >Comentario</span
            >
          </q-card-section>
          <q-separator />
          <q-card-section
            style="min-height: 200px"
            class="q-ml-sm text-area-card"
          >
            <q-input
              type="textarea"
              label="Digite o Comentario"
              dense
              style="width: 447px"
              outlined
              :disable="autenticacao"
              v-model="dados.observacao"
            />
          </q-card-section>

          <q-card-actions align="right">
            <q-btn
              icon="done"
              no-caps
              style="border-radius: 8px"
              class="q-ml-sm"
              color="brand-1"
              label="Concluir Comentario"
              v-close-popup
            />
          </q-card-actions>
        </q-card>
      </q-dialog>
    </q-page>
    <div
      v-if="finishModal"
      class="column q-pa-sm text-white text-weight-bolder bg-brand-1"
      style="
        width: 100%;
        height: 100%;
        z-index: 99999;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        justify-content: center;
        align-items: center;
      "
    >
      <span style="font-size: 64px">RETIRADA</span>
      <q-icon size="158px" class="q-mr-sm" name="check_circle" />
      <span style="font-size: 64px">FINALIZADA</span>
    </div>
    <div class="modal-fixed-container">
      <q-btn
        v-if="firstStep && userData.nome != ''"
        @click="carrinhoModal = !carrinhoModal"
        class="floatButton"
        color="brand-1"
        size="30px"
        round
        icon="shopping_cart"
        :class="{ bounce2: animationActive }"
      >
        <q-badge color="brand-1" floating>{{
          produtosSelecionadosNew?.length
        }}</q-badge>
      </q-btn>

      <q-btn
        v-else-if="firstStep == false && userData.nome != ''"
        @click="authModal = !authModal"
        color="positive"
        size="30px"
        class="floatButton"
        round
        icon="done"
      >
        <q-badge color="brand-1" floating>{{
          produtosSelecionadosNew?.length
        }}</q-badge>
      </q-btn>
    </div>
  </div>
</template>

<script>
import { onMounted, ref, watch, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { useRouter } from "vue-router";

import inputComponentNew from "../components/inputComponentNew.vue";
import ComponenteBiometriaFacial from "../../../components/biometriaFacial/ComponenteBiometriaFacial.vue";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import TabelaHistoricoRetirada from "../components/TabelaHistoricoRetirada.vue";
import Canvas from "../components/Canvas.vue";
import SelecaoSolicitante from "../components/SelecaoSolicitante.vue";
import ComponenteBiometria from "../../../components/biometriaNovo/ComponenteBiometria.vue";

const columns = [
  {
    name: "image",
    label: "Imagem",
    align: "center",
    style: "white-space: normal",
  },
  {
    name: "code",
    label: "Código",
    field: "code",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "name",
    label: "Nome",
    field: "name",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "estoque",
    label: "Quantidade em Estoque",
    field: (row) => row?.estoque,
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "max_amount",
    label: "Quantidade da Regra",
    field: (row) => row?.max_amount,
    align: "center",
    style: "white-space: normal",
  },
  {
    name: "retirada",
    label: "Próxima Retirada em",
    align: "left",
    field: "retirada",
    sortable: false,
    style: "white-space: normal",
  },
  {
    name: "critico",
    label: "Crítico",
    align: "left",
    field: "critico",
    sortable: false,
    style: "white-space: normal",
  },
  {
    name: "quantidade",
    label: "Quantidade",
    align: "left",
    field: "quantidade",
    sortable: false,
    style: "white-space: normal",
  },

  {
    name: "adicionar",
    label: "Adicionar",
    field: "adicionar",
    align: "left",
    style: "white-space: normal",
  },
];

const columns2 = [
  {
    name: "image",
    label: "Imagem",
    align: "center",
  },
  {
    name: "code",
    label: "Código",
    field: "code",
    align: "left",
  },
  {
    name: "name",
    label: "Nome",
    field: "name",
    align: "left",
  },

  {
    name: "quantidade",
    label: "Quantidade",
    align: "left",
    field: "quantidade",
    sortable: false,
  },
  {
    name: "remover",
    label: "Remover",
    align: "center",
    field: "remover",
    sortable: false,
  },
];

export default {
  components: {
    ListaUnidadesSelect,
    TabelaHistoricoRetirada,
    Canvas,
    SelecaoSolicitante,
    inputComponentNew,
    ComponenteBiometria,
    ComponenteBiometriaFacial,
  },
  setup() {
    const store = useStore();
    const quasar = useQuasar();
    const atualDate = ref(new Date().toLocaleString("pt-br"));
    let unidade = ref({
      nome: store.state.org.unidadeData,
      id: store.state.org.unidadeData.id,
    });
    const grupoProdutoList = ref([]);
    const grupoSelected = ref(null);
    const firstStep = ref(true);
    const animationActive = ref(false);
    const facial = ref(false);
    const listaProdutosNewData = ref([]);
    const listaContratosOptions = ref([]);
    const dados = ref({
      contrato: { label: "Contrato", id: "" },
      usuario: "",
      observacao: "",
      dataAtual: new Date().toLocaleDateString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      }),
      idRequisicaoGerada: "",
      tipoAutenticacao: "",
      solicitanteId: "",
    });
    const filtros = ref({
      usuario: "",
      produto: "",
      tipoRequisicao: "",
      selecionados: "",
    });
    const listaUsuarios = ref([]);
    let loadingInner = ref(false);
    const listaProdutos = ref([]);
    const finishModal = ref(false);
    const pesquisarGrupo = ref("");
    const selected = ref([]);
    const numberTentativa = ref(0);
    const time = ref(null);
    const tab = ref("");
    const produtosSelecionadosNew = ref([]);
    const router = useRouter();
    const authModal = ref(false);
    const commentModal = ref(false);
    const loadingCriarReq = ref(false);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 5,
      rowsNumber: 6,
    });

    let autenticacao = ref(false);
    const pin = ref("");
    const unidadeList = ref([]);

    let biometria = ref(false);
    let imagemBase64 = ref(null);
    const userData = ref({
      nome: "",
      ghe: "",
      matricula: "",
      unidade: "",
      centro: "",
      cargo: "",
    });
    let mobile = ref(false);
    let loading = ref(false);
    let usuarioVerificado = ref(false);
    const listarTodos = ref(
      store.state.autenticacao.cliente.indexOf("acciona") != -1 ||
        store.state.autenticacao.cliente.indexOf("staging-acciona") != -1
        ? true
        : false
    );
    let salvarAssinatura = ref(0);
    let atualizarUsuario = ref(0);
    const lotes = ref([]);
    const botaoRequisicaoTravar = ref(false);
    const userLogadoId = ref("");
    const item = ref({ nome: "", id: "" });
    const carrinhoModal = ref(false);
    const atualizarHistorico = ref(0);
    const per_page = ref(4);
    const tipo = ref(undefined);

    if (quasar.platform.is.mobile) {
      mobile = ref(true);
      dados.value.tipoAutenticacao = "";
    }
    const listarContratos = async () => {
      await unidade.value.id;
      try {
        const response = await store.dispatch("requisicao/listarContratos", {
          per_page: 100,
        });
        let array = response.data.results.data;
        listaContratosOptions.value = [];
        array.forEach((contrato) => {
          listaContratosOptions.value.push({
            label: contrato.contract.description,
            id: contrato.pivot.vendor_id,
          });
        });
        selecionarContrato();
      } catch (error) {
        console.log(error);
      }
    };

    const selecionarContrato = () => {
      let valor = listaContratosOptions.value.filter((contrato) => {
        return contrato.id == unidade.value.id;
      });
      dados.value.contrato.label = valor[0]?.label;
      dados.value.contrato.id = valor[0]?.id;
    };

    const listarUsuarios = async (val) => {
      await store.state.autenticacao.cliente;
      try {
        loadingInner.value = true;
        const response = await store.dispatch("requisicao/listarSolicitante", {
          per_page: 4,
          vendor_id:
            store.state.autenticacao.cliente.includes("acciona") ||
            store.state.autenticacao.cliente.includes("vale-epiexpress")
              ? ""
              : unidade.value.id,
          search: val,
        });

        listaUsuarios.value = response.data.results.data.map((e) => {
          return { alternativeName: `${e.name} - ${e.email}`, ...e };
        });

        if (autenticacao.value) {
          let array = listaUsuarios.value.filter((user) => {
            return dados.value.usuario.id == user.id;
          });
          dados.value.usuario = array[0];
        }
        loadingInner.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const listarProdutosNew = async () => {
      listaProdutosNewData.value = [];

      try {
        loading.value = true;
        const response = await store.dispatch("requisicao/listarProdutos", {
          vendor_id: unidade.value.id,
          search: filtros.value.produto,
          contract_id: await store.state.org.contract,
          plantiff_id: dados.value.usuario?.idTabela,
          has_ca: filtros.value.tipoRequisicao,
        });

        response.data.results.data.products.forEach((e) => {
          listaProdutosNewData.value.push({
            ...e,
            ca_codigo: e?.pivot?.ca?.code,
          });
        });

        loading.value = false;
        quasar.loading.hide();
        return;
      } catch (error) {
        console.log(error);
      }
    };

    const listarProdutosLiberados = async (page = 1, perPage = 5) => {
      // Verificar se temos usuário selecionado
      if (!dados.value.usuario?.idTabela) {
        loading.value = false;
        return;
      }

      listaProdutos.value = [];
      try {
        loading.value = true;
        const response = await store.dispatch(
          "simplificadoStore/listarProdutosLiberados",
          {
            vendor_id: unidade.value.id,
            user_id: dados.value.usuario?.idTabela,
            search:
              filtros.value.produto == "" ? undefined : filtros.value.produto,
            grupo_id: grupoSelected.value?.id,
            page: page,
            per_page: perPage,
            tipo: tipo.value,
          }
        );

        if (response.data.result.data.length > 0) {
          if (listarTodos.value) {
            listaProdutos.value = [];
            response.data.result.data.forEach((e) => {
              if (parseFloat(e.estoque) > 0) {
                listaProdutos.value.push({
                  product_images: [],
                  name: e.descricao,
                  description: e.descricao,
                  stock: [
                    {
                      pivot: { amount: e.estoque },
                      minimal_amount: e.estoque_minimo,
                    },
                  ],
                  code: e.codigo_produto,
                  id: e.produto_id,
                  pode_retirar: e.pode_retirar,
                  max_amount: e.max_amount,
                  estoque: e.estoque,
                  withdrawal_amount: e.withdrawal_amount,
                  next_minimum_withdrawal: e.next_minimum_withdrawal,
                  ca_codigo: e.ca_codigo || e?.pivot?.ca?.code,
                  pivot: { price: e.preco },
                  critico: e.critico,
                });
              }
            });

            loading.value = false;
            if (produtosSelecionadosNew.value.length > 0) {
              adicionarQuantidadeProdutosSelecionados();
            }
            return;
          }

          let novaLista = response.data.result.data.map((e) => {
            return {
              product_images: [],
              name: e.descricao,
              description: e.descricao,
              stock: [
                {
                  pivot: { amount: e.estoque },
                  minimal_amount: e.estoque_minimo,
                },
              ],
              code: e.codigo_produto,
              id: e.produto_id,
              pode_retirar: e.pode_retirar,
              max_amount: e.max_amount,
              estoque: e.estoque,
              withdrawal_amount: e.withdrawal_amount,
              next_minimum_withdrawal: e.next_minimum_withdrawal,
              ca_codigo: e.ca_codigo || e?.pivot?.ca?.code,
              pivot: { price: e.preco },
              critico: e.critico,
            };
          });

          listaProdutos.value = novaLista;
          if (produtosSelecionadosNew.value.length > 0) {
            adicionarQuantidadeProdutosSelecionados();
          }
          loading.value = false;
          pagination.value.page = response.data.result.current_page;
          pagination.value.rowsNumber = response.data.result.total;
          pagination.value.rowsPerPage = response.data.result.per_page;
          return;
        }
        listaProdutos.value = [];
        loading.value = false;
      } catch (error) {
        loading.value = false;
        console.log(error);
      }
    };

    const removerProduto = (id) => {
      selected.value = selected.value.filter((produto) => {
        return produto.id != id;
      });
    };

    const criarRequisicao = async () => {
      loadingCriarReq.value = true;

      if (produtosSelecionadosNew.value.length == 0) {
        quasar.notify({
          message: "Selecione ao menos um item para criar a requisição.",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        loadingCriarReq.value = false;
        return;
      }
      let produtos = [];
      produtosSelecionadosNew.value.forEach((produto) => {
        let array = [];
        array = Object.keys(produto);
        let existe = array.some((value) => value == "quantidade");
        if (!existe || produto.quantidade <= 0) {
          quasar.notify({
            message: `O item ${produto.name} está com quantidade zerada, altere a quantidade ou remova o item para seguir!`,
            color: "negative",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          loadingCriarReq.value = false;
          return;
        }
        produtos.push({
          amount: parseInt(produto.quantidade),
          descricao: produto.name,
          endereco: produto.stock[0]?.pivot.address,
          estoque: produto.stock[0]?.pivot.amount,
          estoque_minimo: produto.stock[0]?.pivot.minimal_amount,
          id: produto.id,
          pode_retirar: produto.pode_retirar,
          preco: produto.pivot.price,
          unidade_medida: produto.stock[0]?.pivot.measurement_unit,
        });
      });
      if (produtosSelecionadosNew.value.length != produtos.length) {
        loadingCriarReq.value = false;
        return;
      }
      botaoRequisicaoTravar.value = true;
      try {
        quasar.loading.show();
        const response = await store.dispatch("requisicao/criarRequisicao", {
          cost_center_id: dados.value.usuario?.centroCusto,
          description: dados.value.observacao || undefined,
          plantiff_id: dados.value.usuario?.idTabela,
          products: produtos,
          vendor_id: unidade.value.id,
        });
        quasar.notify({
          message:
            "Voucher criado com sucesso! Ele está como rascunho, você deve entrar na listagem de vouchers e envia-lo para aprovação para dar sequência a retirada dos itens.",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        dados.value.idRequisicaoGerada = response.data.model.id;
        dados.value.solicitanteId = response.data.model.plantiff_id;
        autenticacao.value = true;
        botaoRequisicaoTravar.value = false;
        loadingCriarReq.value = false;
        carrinhoModal.value = false;

        // definir tab inicial baseado nas permissoes
        const permissoes =
          store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles;

        if (permissoes.indexOf("voucher-auth-assinatura") != -1) {
          tab.value = "aprovacao";
          dados.value.tipoAutenticacao = "assinatura";
        } else if (permissoes.indexOf("voucher-auth-biometria") != -1) {
          tab.value = "finalizacao";
          dados.value.tipoAutenticacao = "biometria";
        } else if (permissoes.indexOf("vouchers-auth-facial") != -1) {
          tab.value = "finalizadas";
          dados.value.tipoAutenticacao = "facial";
        } else if (permissoes.indexOf("voucher-auth-pin") != -1) {
          tab.value = "deletadas";
          dados.value.tipoAutenticacao = "web_pin";
        }

        authModal.value = true;
        firstStep.value = false;
        produtosSelecionadosNew.value = [];
        await detalharRequisicao();
        quasar.loading.hide();
      } catch (error) {
        quasar.loading.hide();
        console.log(error);
        botaoRequisicaoTravar.value = false;
        loadingCriarReq.value = false;
        quasar.notify({
          message: "Erro ao criar voucher",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    watch(
      () => pagination.value.page,
      () => {
        listarProdutosLiberados(
          pagination.value.page,
          pagination.value.rowsPerPage
        );
      }
    );

    const gerarDataAtual = () => {
      let dataAtual = new Date();

      let mesAtual = dataAtual.getMonth() + 1;
      let diaAtual = dataAtual.getDate();
      let anoAtual = dataAtual.getFullYear();

      dados.value.dataAtual = anoAtual + "-" + mesAtual + "-" + diaAtual;
    };

    const recebeAssinatura = async (value) => {
      imagemBase64.value = value;
      finalizarRequisicao();
    };

    const atualizarTemplatesBiometria = async () => {
      try {
        await store.dispatch("user/atualizarTemplatesBiometria");
        atualizarUsuario.value++;
      } catch (error) {
        console.log(error);
      }
    };

    const checarPin = async () => {
      if (pin.value == "") {
        quasar.notify({
          message: "O campo não pode estar vazio",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      try {
        const response = await store.dispatch("requisicao/checarPin", {
          pin: pin.value,
          user_id: dados.value.solicitanteId,
        });
        if (response.data.result.pin_correto) {
          quasar.notify({
            message:
              "Senha Validada com Sucesso, a requisição será finalizada!",
            color: "positive",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          usuarioVerificado.value = true;
          finalizarRequisicao();
        } else {
          quasar.notify({
            message: "PIN digitado, não corresponde ao pin do usuário!",
            color: "negative",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      } catch (error) {
        quasar.notify({
          message: "Erro ao validar pin",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const finalizarRequisicao = async () => {
      if (dados.value.tipoAutenticacao == "web_pin") {
        imagemBase64.value = pin.value;
      }
      if (
        dados.value.tipoAutenticacao != "token" &&
        imagemBase64.value == null
      ) {
        quasar.notify({
          message:
            "Realize a autenticação para a fazer a finalização do voucher.",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (
        !usuarioVerificado.value &&
        dados.value.tipoAutenticacao == "biometria"
      ) {
        quasar.notify({
          message: "A Biometria coletada não coincide com a do solicitante",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (
        imagemBase64.value == null &&
        dados.value.tipoAutenticacao == "facial"
      ) {
        quasar.notify({
          message: "Erro a o encontrar imagem da face",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      botaoRequisicaoTravar.value = true;
      try {
        quasar.loading.show();
        await store.dispatch("requisicao/finalizar", {
          reqId: dados.value.idRequisicaoGerada,
          imagemBase64:
            dados.value.tipoAutenticacao != "token"
              ? imagemBase64.value
              : store.state.autenticacao.token,
          idUsuario: dados.value.usuario?.idTabela,
          batches: lotes.value,
          date: gerarTimestamp(),
          auth_type: dados.value.tipoAutenticacao,
        });
        quasar.notify({
          message: "Requisição finalizada com sucesso.",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        setTimeout(() => {
          botaoRequisicaoTravar.value = false;
          userData.value = {
            nome: "",
            ghe: "",
            matricula: "",
            unidade: "",
            centro: "",
            cargo: "",
          };
          grupoSelected.value = null;
          authModal.value = false;
          firstStep.value = true;
        }, 2000);
        finishModal.value = true;
        setTimeout(() => {
          finishModal.value = false;
        }, 2000);
        quasar.loading.hide();
      } catch (error) {
        quasar.loading.hide();
        console.log(error);
        botaoRequisicaoTravar.value = false;
        quasar.notify({
          message: error.response.data.message,
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const receberResultadoBiometria = (value) => {
      usuarioVerificado.value = value?.resultadoVerificacao;

      const bioNegativa = value?.biometriaNegativa;
      if (Array.isArray(bioNegativa)) {
        imagemBase64.value = bioNegativa[0];
      } else if (typeof bioNegativa === "string") {
        imagemBase64.value = bioNegativa;
      } else {
        imagemBase64.value = bioNegativa;
      }
    };

    const userLogado = async () => {
      let response = await store.dispatch("requisicao/userLogado");
      userLogadoId.value = response.data.id;
    };

    const detalharRequisicao = async () => {
      lotes.value = [];
      try {
        const response = await store.dispatch("requisicao/detalharVoucher", {
          voucher_id: dados.value.idRequisicaoGerada,
        });
        let produtos = response.data.model.products;
        produtos.forEach((e) => {
          let produtoQuantidade = e.pivot?.amount;
          e.lotes.sort((a, b) => {
            if (a.expiration_date == null || b.expiration_date == null) {
              if (a.expiration_date == null) {
                return -1;
              }
              if (b.expiration_date == null) {
                return 1;
              }
            }
            if (a.expiration_date != null && b.expiration_date != null) {
              if (a.expiration_date > b.expiration_date) {
                return 1;
              }
              if (b.expiration_date > a.expiration_date) {
                return -1;
              }
            }
            return 0;
          });
          let stockVendor = e.stock.filter(
            (stock) => stock.vendor_id === store.state.org.unidadeData.id
          );
          if (e.lotes.length > 0 && stockVendor[0]?.pivot?.batch_control == 1) {
            e.lotes.forEach((lote, indice) => {
              if (
                parseFloat(lote.amount) > parseFloat(produtoQuantidade) &&
                !lotes.value.some((value) => value.product_id == e.id) &&
                lote.vendor_id == stockVendor[0]?.vendor_id
              ) {
                adicionarLote(e.id, produtoQuantidade, lote.batch);
                return;
              }
              if (
                indice + 1 == e.lotes.length &&
                !lotes.value.some((value) => value.product_id == e.id)
              ) {
                e.lotes.forEach((lote) => {
                  if (lote.vendor_id == stockVendor[0]?.vendor_id) {
                    adicionarLote(e.id, produtoQuantidade, lote.batch);
                  }
                });
                return;
              }
            });
          }
        });
      } catch (error) {
        console.log(error);
      }
      loading.value = false;
    };

    const adicionarLote = async (id, quantidade, nome) => {
      lotes.value.push({
        batch: nome,
        amount: quantidade,
        product_id: id,
      });
    };

    const receberFuncionario = (value) => {
      if (value.tipo == undefined || value.tipo == "geral") {
        userData.value.nome = value.name;
        userData.value.ghe = value.function;
        userData.value.centro = value.cost_center?.name;

        userData.value.matricula = value.sap;
        unidadeList.value = value?.vendors;

        dados.value.usuario = {
          idTabela: value?.id,
          nome: value.name,
          matricula: value.sap,
          biometria: value.biometry,
          centroCusto: value?.cost_center?.id,
        };
      }
    };

    const gerarTimestamp = () => {
      const dataAtual = new Date();

      const ano = dataAtual.getUTCFullYear();
      const mes = (dataAtual.getUTCMonth() + 1).toString().padStart(2, "0");
      const dia = dataAtual.getUTCDate().toString().padStart(2, "0");
      const horas = dataAtual.getUTCHours().toString().padStart(2, "0");
      const minutos = dataAtual.getUTCMinutes().toString().padStart(2, "0");
      const segundos = dataAtual.getUTCSeconds().toString().padStart(2, "0");

      return `${ano}-${mes}-${dia}T${horas}:${minutos}:${segundos}Z`;
    };

    const retirarProduto = async (produto) => {
      const index = produtosSelecionadosNew.value.findIndex((id) => {
        return id.id == produto.id;
      });
      if (index != -1) {
        produtosSelecionadosNew.value.splice(index, 1);
        return;
      }
      produtosSelecionadosNew.value.push(produto);
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        if (store.state.org.unidadeData == null) {
          return;
        }
        unidade.value.nome = store.state.org.unidadeData;
        unidade.value.id = store.state.org.unidadeData.id;
        selecionarContrato();
        listarGruprosProdutos();
        listaUsuarios.value = [];
      }
    );

    watch(
      () => filtros.value.usuario,
      () => {
        listarProdutosLiberados();
      }
    );

    watch(
      () => produtosSelecionadosNew.value.length,
      () => {
        animationActive.value = true;

        setTimeout(() => {
          animationActive.value = false;
        }, 2000);
      }
    );

    watch(
      () => userData.value.nome,
      () => {
        listarProdutosLiberados();
      }
    );

    watch(
      () => dados.value.tipoAutenticacao,
      () => {
        if (dados.value.tipoAutenticacao == "token") {
          imagemBase64.value = null;
          pin.value = "";
          usuarioVerificado.value = true;
          return;
        }
        imagemBase64.value = null;
        pin.value = "";
        usuarioVerificado.value = false;
      }
    );

    watch(
      () => grupoSelected.value,
      () => {
        listarProdutosLiberados();
      }
    );

    const listarGruprosProdutos = async (val) => {
      try {
        const response = await store.dispatch(
          "simplificadoStore/listarGrupoProdutos",
          {
            search: val,
            unidade: unidade.value.id,
          }
        );

        grupoProdutoList.value = response.data.results.data;
      } catch (error) {
        console.log(error);
      }
    };

    const getVencidos = async () => {
      try {
        quasar.loading.show();
        const response = await store.dispatch(
          "simplificadoStore/vencidosList",
          {
            user_id: dados.value.usuario?.idTabela,
            search: filtros.value.produto,
            per_page: 5,
          }
        );

        let novaLista = response.data.results.data.map((e) => {
          return {
            product_images: [],
            name: e.name,
            description: e.pivot.contract_product_description,
            stock: e.stock,
            code: e.code,
            id: e.pivot.product_id,
            pode_retirar: "Sim",
            max_amount: e?.max_amount?.toString(),
            withdrawal_amount: e.withdrawal_amount,
            next_minimum_withdrawal: e.next_minimum_withdrawal,
            ca_codigo: e?.pivot?.ca,
            pivot: { price: e?.pivot?.price },
          };
        });

        listaProdutos.value = novaLista;
        quasar.loading.hide();
      } catch (error) {
        quasar.loading.hide();
        console.log(error);
      }
    };

    const backPage = async () => {
      router.push({ name: "spf-materiais" });
    };

    onMounted(() => {
      listarContratos();
      listarGruprosProdutos();
      gerarDataAtual();
      userLogado();
    });

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        unidade.value.nome = JSON.parse(getunidade);
      }
    };

    const compararData = (data, pode_retirar) => {
      if (pode_retirar == "Sim") {
        if (
          data.next_minimum_withdrawal == undefined ||
          data.next_minimum_withdrawal == null
        ) {
          return ``;
        }

        let dataPrincipal = data.next_minimum_withdrawal.split(" ")[0];
        var partesData = dataPrincipal.split("-");
        var newData = new Date(partesData[0], partesData[1] - 1, partesData[2]);

        if (newData <= new Date()) {
          return ``;
        } else {
          return parseFloat(data?.max_amount) -
            parseFloat(data?.withdrawal_amount) ==
            0
            ? ``
            : ``;
        }
      } else if (pode_retirar == "Não") {
        return data.next_minimum_withdrawal
          .split(" ")[0]
          .split("-")
          .reverse()
          .join("/");
      }
    };

    const compararDataValue = (data, pode_retirar) => {
      if (pode_retirar == "Sim") {
        if (
          data.next_minimum_withdrawal == undefined ||
          data.next_minimum_withdrawal == null
        ) {
          return false;
        }

        let dataPrincipal = data.next_minimum_withdrawal.split(" ")[0];
        var partesData = dataPrincipal.split("-");
        var newData = new Date(partesData[0], partesData[1] - 1, partesData[2]);

        if (newData <= new Date()) {
          return false;
        } else {
          return parseFloat(data?.max_amount) -
            parseFloat(data?.withdrawal_amount) ==
            0
            ? false
            : false;
        }
      } else if (pode_retirar == "Não") {
        return true;
      }
    };

    const verificarQuantidade = (row) => {
      const retirado =
        row.withdrawal_amount != null ? row.withdrawal_amount : 0;

      const valorMaximo = row.max_amount;

      let dataPrincipal = row?.next_minimum_withdrawal?.split(" ")[0];
      var partesData = dataPrincipal ? dataPrincipal.split("-") : null;
      var newData =
        partesData != null
          ? new Date(partesData[0], partesData[1] - 1, partesData[2])
          : null;

      const verificarData =
        parseFloat(valorMaximo) - parseFloat(retirado) != 0
          ? parseFloat(valorMaximo) - parseFloat(retirado)
          : newData <= new Date()
          ? parseFloat(valorMaximo)
          : 0;

      /* eslint-disable-next-line */
      if (
        parseFloat(row.quantidade) > parseFloat(verificarData) ||
        row.pode_retirar == "Não"
      ) {
        return true;
      } else {
        return false;
      }
    };

    function calcularDiasFaltando(dataFutura) {
      // Obter a data atual
      const dataAtual = new Date();

      // Converter a data futura para um objeto Date
      const dataAlvo = new Date(dataFutura);

      // Calcular a diferença em milissegundos
      const diferencaEmMilissegundos = dataAlvo - dataAtual;

      // Converter milissegundos para dias (1 dia = 24 horas * 60 minutos * 60 segundos * 1000 milissegundos)
      const milissegundosPorDia = 1000 * 60 * 60 * 24;
      const diferencaEmDias = Math.ceil(
        diferencaEmMilissegundos / milissegundosPorDia
      );

      return diferencaEmDias;
    }

    onMounted(getUnidade);

    onMounted(listarContratos);
    onMounted(gerarDataAtual);

    const handleScroll = (e) => {
      let tentativa = numberTentativa.value;

      const { scrollTop, offsetHeight, scrollHeight } = e.target;
      if (scrollTop + offsetHeight >= scrollHeight) {
        numberTentativa.value++;

        if (tentativa != numberTentativa.value) {
          time.value = setTimeout(async () => {
            per_page.value = per_page.value + 4;
            quasar.loading.show();
            await listarProdutosNew();
          }, 1000);
        }
      }
    };

    const adicionarQuantidadeProdutosSelecionados = () => {
      if (produtosSelecionadosNew.value.length === 0) {
        return;
      }
      let produtos = [];
      produtosSelecionadosNew.value.forEach((produto) => {
        let produtoListaIndex = listaProdutos.value.findIndex(
          (value) => value.id === produto.id
        );

        if (produtoListaIndex != -1) {
          listaProdutos.value[produtoListaIndex].quantidade =
            produto.quantidade;
          produtos.push(listaProdutos.value[produtoListaIndex]);
        }
      });
      produtosSelecionadosNew.value = produtos;
    };

    const fecharFacial = async () => {
      facial.value = false;
    };

    const receberFace = async (resultado) => {
      if (resultado.resultadoVerificacao) {
        imagemBase64.value = resultado?.imagemVerificacao;
        facial.value = false;

        quasar.notify({
          message: "Face verificada com sucesso, finalizando retirada...",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });

        setTimeout(() => {
          finalizarRequisicao();
        }, 500);
      } else {
        quasar.notify({
          message: "Face não reconhecida. Tente novamente.",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const resetState = async () => {
      authModal.value = false;
      tab.value = "";
      dados.value.tipoAutenticacao = "";
      setTimeout(() => {
        botaoRequisicaoTravar.value = false;
        userData.value = {
          nome: "",
          ghe: "",
          matricula: "",
          unidade: "",
          centro: "",
          cargo: "",
        };
        grupoSelected.value = null;

        firstStep.value = true;
      }, 800);
      quasar.notify({
        message:
          "Você cancelou a ação de finalização, acesse a listagem para completar o processo",
        color: "negative",
        actions: [
          {
            label: "fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
    };

    watch(
      () => filtros.value.produto,
      () => {
        listarProdutosLiberados();
      }
    );

    const compararDataCritico = (data) => {
      if (
        data.next_maximum_withdrawal == undefined ||
        data.next_maximum_withdrawal == null
      ) {
        return true;
      }

      let dataPrincipal2 = data.next_maximum_withdrawal.split(" ")[0];
      var partesData2 = dataPrincipal2.split("-");

      var dataProximaRetiradaMaxima = new Date(
        partesData2[0],
        partesData2[1] - 1,
        partesData2[2]
      );

      if (dataProximaRetiradaMaxima < new Date()) {
        return true;
      } else {
        return false;
      }
    };

    return {
      compararDataCritico,
      columns,
      fecharFacial,
      unidade,
      receberFuncionario,
      listarContratos,
      authModal,
      receberFace,
      dados,
      lotes,
      botaoRequisicaoTravar,
      listaContratosOptions,
      backPage,
      facial,
      selecionarContrato,
      handleScroll,
      listarUsuarios,
      getVencidos,
      filtros,
      listaUsuarios,
      loadingInner,
      calcularDiasFaltando,
      listarGruprosProdutos,
      listaProdutos,
      selected,
      compararDataValue,
      removerProduto,
      listarProdutosLiberados,
      criarRequisicao,
      autenticacao,
      adicionarLote,
      detalharRequisicao,
      gerarDataAtual,
      pin,
      biometria,
      atualizarTemplatesBiometria,
      checarPin,
      imagemBase64,
      tipo,
      mobile,
      finalizarRequisicao,
      loading,
      listarTodos,
      receberResultadoBiometria,
      usuarioVerificado,
      pesquisarGrupo,
      atualizarUsuario,
      finishModal,
      userLogado,
      unidadeList,
      tab,
      animationActive,
      recebeAssinatura,
      salvarAssinatura,
      listaProdutosNewData,
      gerarTimestamp,
      carrinhoModal,
      grupoSelected,
      atualDate,
      item,
      atualizarHistorico,
      quasar,
      userData,
      commentModal,
      firstStep,
      compararData,
      grupoProdutoList,
      retirarProduto,
      produtosSelecionadosNew,
      columns2,
      loadingCriarReq,
      verificarQuantidade,
      pagination,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      resetState,
      adicionarQuantidadeProdutosSelecionados,
      filtrarCusto(val, update) {
        listarGruprosProdutos(val);
        setTimeout(() => {
          update();
        }, 500);
      },
      filterFn(val, update) {
        listarUsuarios(val);
        setTimeout(() => {
          update();
        }, 300);
      },
    };
  },
};
</script>

<style>
.input-new-design .q-field--outlined .q-field__control {
  border-radius: 8px !important;
}
.table-style-simple .q-table__top {
  padding: 6px 0px !important;
}
</style>

<style scoped>
a {
  text-decoration: none;
}
.info-user {
  padding: 12px;
  height: 150px;
  max-width: 890px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  margin-top: 26px;
}
.card-nome-usuario {
  background-color: #7ab9e0;
  color: white;
  padding: 5px 10px;
  border-radius: 8px;
}
.border-select {
  border: 1px solid #213864 !important;
}

.text-area-card textarea {
  height: 300px;
}

.new-produto-selected {
  border: 2px solid #213864 !important;
  background-color: #7ab9e0;
}
.container-autenticacao-pin {
  width: 100%;
  flex-wrap: nowrap;
}

.container-autenticacao-pin div {
  width: 80%;
}

.tab-active-new-products {
  background-color: #304f78;
  color: white;
}

.align {
  align-items: center;
}

.card-produtcs-todos-new {
  border: solid 1px #d9d9d9;
  margin-left: 12px;
  margin-right: 12px;
  height: 88px;
  max-height: 88px;
  margin-top: 16px;
  display: flex;
  border-radius: 8px;
  align-items: center;
}

.info-product-user {
  padding: 12px;
  gap: 8px;
  max-height: 367px;
  overflow-y: scroll;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  margin-top: 26px;
}
.align-center {
  align-items: center;
}

.modal-fixed-container {
  width: 100%;
  top: 0;
  height: 100%;
  display: flex;
  position: absolute;
  /* margin-top: 40px; */
  left: 0;

  overflow: auto;
  justify-content: flex-end;
  align-items: flex-end;
}

.floatButton {
  -webkit-box-shadow: 3px 0px 5px 1px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 3px 0px 5px 1px rgba(0, 0, 0, 0.75);
  box-shadow: 3px 0px 5px 1px rgba(0, 0, 0, 0.75);
  max-height: 90px;
  position: fixed;
  bottom: 16px;
  right: 19px;
  margin-left: 15px;
  z-index: 10000;
}

.info-product-user div {
  align-items: center;
  width: 333px;
  height: 68px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  font-size: 12px;
}
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

.q-table--loading thead tr:last-child th {
  top: 48px;
}
.my-sticky-dynamic {
  max-height: 400px;
}
thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:last-child th {
  top: 48px;
}
thead tr:first-child th {
  top: 0;
}
.texto-titulo-tabela {
  font-size: 18px;
}
.texto-autenticacao {
  font-size: 18px;
}
.imagem-biometria {
  height: 80px;
  width: 80px;
  cursor: pointer;
}
.radio-input {
  width: 24%;
}
.mobile {
  display: none;
}
.texto-link {
  font-size: 19px;
  margin-bottom: 4px;
  font-weight: bold;
}
.video {
  height: 300px;
  width: 450px;
}
.texto-link-legenda {
  font-size: 16px;
}
.texto-toggle {
  font-size: 14px;
}

.bounce2 {
  animation: bounce2 2s ease infinite;
}
@keyframes bounce2 {
  0%,
  20%,
  50%,
  80%,
  100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-30px);
  }
  60% {
    transform: translateY(-15px);
  }
}
@media (max-width: 600px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
  .my-sticky-dynamic {
    max-height: 1000px;
  }
  .text-grid-table {
    font-size: 11px;
  }
  .card {
    border: 1px solid #707070;
    border-radius: 5px;
  }
  .texto-titulo {
    font-size: 14px;
  }
  .container-inputs {
    margin: 0px 0px 0px 0px;
  }

  .texto-titulo-input {
    font-size: 12px;
    margin: 0px;
  }
  .canvas-container {
    width: 100%;
  }
  .input {
    font-size: 12px;
  }
  .select {
    font-size: 12px;
  }
  .container-radio {
    margin: 29px 0px 10px 0px;
  }
  .texto-titulo-tabela {
    margin: 0px 0px 0px 6px;
    font-size: 14px;
  }
  .radio-input {
    margin: 0px 0px 0px 0px;
    font-size: 10px;
    width: 50%;
  }
  .radio-input-tipo {
    font-size: 12px;
    margin: 6px 0px 0px 0px;
  }
  .texto-alerta {
    margin: 0px 0px 0px 0px;
  }
  .container-btn {
    justify-content: flex-end;
  }
  .texto-autenticacao {
    font-size: 13px;
  }
  .container-autenticacao {
    margin: 0px 0px 0px 0px;
  }
  .input-grid {
    width: 70px;
    outline: none;
  }
  .img-container-grid {
    border: 2px solid #b4b4b4;
    border-radius: 5px;
    font-weight: bold;
    width: 90px;
    height: 110px;
  }
  .img-grid {
    max-width: 100%;
    height: 100%;
  }
  .input-quantidade {
    margin: 0px;
    padding-left: 11px;
    font-size: 14px;
  }
  .input-quantidade-container {
    margin: 0px 0px 0px 0px;
    padding: 0px;
    height: 32px;
  }
  .titulo-input-unidade {
    font-size: 12px;
  }
  .titulo-input-tipo-requisicao {
    font-size: 12px;
  }
  .arrow {
    color: white;
    font-size: 25px;
    border-radius: 5px;
    cursor: pointer;
  }
  .container-video {
    width: 100%;
  }
  .texto-link {
    font-size: 12px;
    margin-bottom: 4px;
  }
  .video {
    height: 100%;
    width: 100%;
  }
  .sem-margin {
    margin: 0px;
  }
  .texto-link-legenda {
    font-size: 14px;
  }
  @media only screen and (max-width: 368px) {
    .arrow {
      color: white;
      font-size: 21px;
      border-radius: 5px;
      cursor: pointer;
    }
  }
}
</style>
